export var Steps;
(function (Steps) {
    Steps[Steps["insurance"] = 0] = "insurance";
    Steps[Steps["plan"] = 1] = "plan";
    Steps[Steps["customer"] = 2] = "customer";
    Steps[Steps["beneficiary"] = 3] = "beneficiary";
    Steps[Steps["confirmData"] = 4] = "confirmData";
    Steps[Steps["pay"] = 5] = "pay";
    Steps[Steps["vehiclesDetails"] = 7] = "vehiclesDetails";
    Steps[Steps["auditDocumentUrl"] = 8] = "auditDocumentUrl";
    Steps[Steps["initialInfo"] = 9] = "initialInfo";
    Steps[Steps["applicantDeclaration"] = 10] = "applicantDeclaration";
    Steps[Steps["financialInformation"] = 11] = "financialInformation";
    Steps[Steps["medicalInformation"] = 12] = "medicalInformation";
    Steps[Steps["applicantInformation"] = 13] = "applicantInformation";
})(Steps || (Steps = {}));
